/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Role_TrainerInputs */

const en_coaches_page_role_trainer = /** @type {(inputs: Coaches_Page_Role_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer`)
};

const pl_coaches_page_role_trainer = /** @type {(inputs: Coaches_Page_Role_TrainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trener`)
};

/**
* | output |
* | --- |
* | "Trainer" |
*
* @param {Coaches_Page_Role_TrainerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_role_trainer = /** @type {((inputs?: Coaches_Page_Role_TrainerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Role_TrainerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_role_trainer(inputs)
	return en_coaches_page_role_trainer(inputs)
});